import {ethers} from "ethers"
import abi from "./abis/nft.json"

export const contractInstance = (signer) => {
    const contract = new ethers.Contract(process.env.REACT_APP_NFT_CONTRACT_ADDRESS, abi, signer)
    return contract;
}